import utils from './utils';
import hproLog from './log';
import notificationAPI from './notification';
import axios from 'axios';

var context = self || window;
var contextType = 'window';
try {
    if (ServiceWorkerGlobalScope) {
        contextType = 'worker';
    }
} catch (e) {

}

'use strict';

function formatSubscription(subscription) {
    var key = subscription.getKey('p256dh');
    var token = subscription.getKey('auth');

    var formatted = {};

    formatted.endpoint = subscription.endpoint;
    formatted.key = key ? btoa(String.fromCharCode.apply(null, new Uint8Array(key))) : null;
    formatted.token = token ? btoa(String.fromCharCode.apply(null, new Uint8Array(token))) : null;

    return formatted;
}

function formatRequestUrl(url, serviceUuid, formUuid) {
    return url
        .replace('{serviceUuid}', serviceUuid)
        .replace('{formUuid}', formUuid);
}

export default function subscriptionService(pushManager, configuration) {
    var self = this;

    /**
     * 
     * @param {*} subscription 
     * @param {Array} requestConfig
     *  {
     *      request, 
     *      method, 
     *      data, 
     *      headers, 
     *      excludeWebPushObject
     *  } 
     */
    function subscriptionRequest(subscription, requestConfig, tag) {
        var finalConfig = {
            identifier: requestConfig.identifier || configuration.identifier,
            serviceUuid: requestConfig.serviceUuid || configuration.serviceUuid,
            formUuid: requestConfig.formUuid || configuration.formUuid,
            method: 'POST',
            data: utils.merge({}, requestConfig['data'] || {}),
            headers: utils.merge({}, requestConfig['headers'] || {}),
            excludeWebPushObject: requestConfig.excludeWebPushObject || false,
        };

        var defaultUrl = configuration.apiUrlPrefix + configuration.apiEndpointFormat;

        var url = formatRequestUrl(
            defaultUrl, finalConfig.data.serviceUuid || finalConfig.serviceUuid, finalConfig.data.formUuid || finalConfig.formUuid
        );

        var identifier = finalConfig.data.identifier || finalConfig.identifier;
        var method = finalConfig.method;

        var sendParams = utils.merge({}, finalConfig.data);
        if (identifier) {
            sendParams['identifier'] = identifier || sendParams['identifier'] || null;
        }

        var headerParams = utils.merge({}, finalConfig.headers);
        headerParams["Content-Type"] = "application/json";
        headerParams["Accept"] = "application/json";

        if (!finalConfig.excludeWebPushObject) {
            sendParams['webpush'] = formatSubscription(subscription);
        }

        // notify that request is to be made
        return self.fetch(url, finalConfig.method, headerParams, sendParams, sendParams['webpush'] || null, finalConfig, tag);
    }

    self.fetch = function (url, method, headerParams, sendParams, subscriptionData, finalConfig, tag) {
        return new Promise(function (resolve, reject) {
            // axios({
            //     url: url,
            //     // headers: headerParams,
            //     method: method,
            //     data: sendParams,
            //     // mode: 'cors'
            // }).then(function (response) {
            //     let d = response.data;
            //     d.subscription = subscriptionData;
            //     resolve(d);
            // }).catch(reject);

            fetch(url, {
                headers: headerParams,
                method: method,
                body: JSON.stringify(sendParams),
                mode: 'cors'
            }).then(function (response) {
                response.json().then(response.ok  ? function (data) {
                    data.subscription = subscriptionData;
                    resolve(data);
                } : reject, reject);
            }).catch(reject);
        });
    }

    self.getSignature = function () {
        return {
            userVisibleOnly: true,
            applicationServerKey: utils.urlBase64ToUint8Array(configuration.applicationServerKey),
        };
    };

    self.getToken = function () {
        return new Promise(function (resolve, reject) {
            hproLog('[subscription] getToken');
            self.read().then(function (subscription) {
                var key = subscription.getKey('p256dh');
                var token = btoa(String.fromCharCode.apply(null, new Uint8Array(subscription.getKey('auth'))));
                hproLog('[subscription] getToken resolve', token);
                resolve(token);

            }, utils.rejectWithReason(reject, 'no_subscription', 'There is no subscription'));
        });
    };

    // request a new subscription
    self.request = function () {
        var promise = pushManager.subscribe(self.getSignature());
        promise.catch(function (e) {
            if (Notification.permission === 'denied') {
                // The user denied the notification permission which
                // means we failed to subscribe and the user will need
                // to manually change the notification permission to
                // subscribe to push messages
                hproLog.warn('Notifications are denied by the user.');
            } else {
                // A problem occurred with the subscription; common reasons
                // include network errors or the user skipped the permission
                hproLog.error('Impossible to subscribe to push notifications', e);
            }
            /* reject(); */
        });

        return promise;
    };

    // current subscription
    self.read = function () {
        var promise = pushManager.getSubscription();
        return new Promise(function (resolve, reject) {
            promise.then(function (subscription) {
                try {
                    validateSubscription(subscription);
                } catch ($reason) {
                    utils.rejectWithReason(reject, $reason['reason'], $reason['description'])({});
                    return;
                }

                resolve(subscription);
            }, utils.rejectWithReason(reject, 'not_subscribed', 'Not Subscribed'));
        });
    };

    // create new subscription
    self.create = function (customData, customHeaders) {
        return new Promise(function (resolve, reject) {
            self.request().then(function (subscription) {
                subscriptionRequest(subscription, {
                    data: customData,
                    headers: customHeaders,
                })
                // .then(resolve, utils.rejectWithReason(reject, 'not_sent', 'Subscription is not sent'));
                .then(resolve, reject);
            // }, utils.rejectWithReason(reject, 'not_created', 'Subscription is not created'));
            }, reject);
        });
    };

    // update subscription
    self.update = function (customData, customHeaders, excludeWebPushObject) {
        return new Promise(function (resolve, reject) {
            self.read()
            .then(function (subscription) {
                subscriptionRequest(subscription, {
                    data: customData || {},
                    headers: customHeaders || {},
                    excludeWebPushObject: excludeWebPushObject
                }).then(resolve, utils.rejectWithReason(reject, 'not_sent', 'Subscription not sent'));
            }, utils.rejectWithReason(reject, 'not_updated', 'Subscription not updated'));
        });
    };

    // remove subscription
    self.remove = function (customData, customHeaders, excludeWebPushObject) {
        // To unsubscribe from push messaging, you need to get the subscription object
        function request(resolve, reject) {
            return subscriptionRequest(null, {
                data: customData,
                headers: customHeaders,
                excludeWebPushObject: true
            }).then(resolve, utils.rejectWithReason(reject, 'not_removed', 'Subscription not removed'));
        }

        return new Promise(function (resolve, reject) {
            self.read().then(function (subscription) {
                subscription.unsubscribe();
                request(resolve, reject);
            }, function (reason) {
                request(resolve, reject);
            });
        });
    };

    self.drop = function () {
        return new Promise(function (resolve, reject) {
            self.read()
                .then(function (subscription) {
                        subscription.unsubscribe().then(resolve, reject);
                    },
                    utils.rejectWithReason(reject, 'drop_failed', 'no-subscription-found')({})
                )
        });
    }

    self.isSubscribed = function () {
        return new Promise(function (resolve, reject) {
            var p = notificationAPI.getPermission();
            if (p == 'denied') {
                utils.rejectWithReason(reject, 'permission_not_granted', 'Permission not granted')();
            } 
            else if (p == 'default') {
                utils.rejectWithReason(reject, 'not_subscribed', 'Not Subscribed')();
            } 
            else {
                self.read()
                    .then(function (subscription) {
                        resolve(true);
                    })
                    .catch(utils.rejectWithReason(reject, 'not_subscribed', 'Not subscribed'));
            }
        });
    };

    function validateSubscription(subscription) {
        if (!subscription) {
            throw {
                reason: 'not_subscribed',
                description: 'Not Subscribed'
            };
        }

        var serverKey = String.fromCharCode.apply(null, new Uint8Array(subscription.options.applicationServerKey));
        serverKey = context.btoa(serverKey);

        if (serverKey != configuration.applicationServerKey) {
            throw {
                reason: 'application_server_key_mismatch',
                description: 'Server key missmatch'
            };
        }

        return true;
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/services/subscription.js
// module id = 19
// module chunks = 0